<template>
  <div class="funsiamo" v-wechat-title="$route.meta.title">
    <div v-if="loading==true">
      <div class="spinner icon-spinner-2" aria-hidden="true"></div>
    </div>
    <div v-if="show==true">
      <div>
        <img id="logo" src="../assets/funsiamo.png">
      </div>
      <div class="buttonrow">
        <button id="closewindowbutton" v-on:click="userPro" :disabled="isDisable">點我註冊/登入會員</button>
      </div>
      <br />
      <footer><a href="https://www.eilis-ai.com/">系統提供 by EILIS智慧互動助理</a></footer>
    </div>
  </div>
</template>

<script>
import Vuex from 'vuex'
import { mapActions,mapGetters,mapState } from 'vuex'
export default {
  name: 'funsiamo',
  data() {
    return {
      loading: true,
      show: false,
      isDisable: false
    }
  },
  methods: {
    userPro: function() {
        this.$store.dispatch('getApi', 
        {
          keyword: this.keyword,
          c: this.channelId
        })
        // 防止重複點擊按鈕
        this.isDisable = true
        setTimeout(() => {
          this.isDisable = false
        }, 2000)
    }
  },
  computed: {
    ...mapGetters({
      keyword: 'keyword'
    }),
    ...mapGetters({
      channelId: 'channelId'
    })
  },
  mounted() {
    document.body.style.backgroundColor="#0A0201"
    setTimeout(() => {
      this.loading = false
      this.show = true
    }, 1500)
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
* {
  /*background-color: #0A0201;*/
  text-align: center;
  font-family: "微軟正黑體";
}
#logo {
  background-color: #0A0201;
  border-radius: 50%;
  width: 38%;
  /*vertical-align : middle;*/
}
#closewindowbutton {
  z-index: 99999;
  color: white;
  font-weight: bolder;
  font-family: "微軟正黑體";
  width: 70%;
  margin-top: 15px;
  margin-bottom: 8px;
  padding: 8px 10px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 20px;
  border: 3px white solid;
  background-color: #0A0201;
  border-radius: 6px;
}
#closewindowbutton:hover {
  background-color: white;
  color: #0A0201;
}
footer {
  bottom: 2px;
  width: 100%;
  color: white;
  font-size: 13px;
  text-align: center;
  padding-bottom: 5px;
}
a {
  color: white;
}
/********/
@font-face {
	font-family: 'icomoon';
	src:url('https://s3.amazonaws.com/icomoon.io/4/Loading/icomoon.eot?-9haulc');
	src:url('https://s3.amazonaws.com/icomoon.io/4/Loading/icomoon.eot?#iefix-9haulc') format('embedded-opentype'),
		url('https://s3.amazonaws.com/icomoon.io/4/Loading/icomoon.woff?-9haulc') format('woff'),
		url('https://s3.amazonaws.com/icomoon.io/4/Loading/icomoon.ttf?-9haulc') format('truetype'),
		url('https://s3.amazonaws.com/icomoon.io/4/Loading/icomoon.svg?-9haulc#icomoon') format('svg');
	font-weight: normal;
	font-style: normal;
}

[class^="icon-"], [class*=" icon-"] {
	font-family: 'icomoon';
	/* speak: none; */
	font-style: normal;
	font-weight: normal;
	font-variant: normal;
	text-transform: none;
	line-height: 1;

	/* Better Font Rendering =========== */
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
}
.icon-spinner-2:before {
	content: "\e001";
}
@keyframes anim-rotate {
	0% {
		transform: rotate(0);
	}
	100% {
		transform: rotate(360deg);
	}
}
.spinner {
	display: inline-block;
	font-size:4em;
	height: 1em;
	line-height: 1;
	margin: .5em;
	animation: anim-rotate 2s infinite linear;
	color: #fff;
	text-shadow: 0 0 .25em rgba(255,255,255, .3);
}
.spinner--steps {
	animation: anim-rotate 1s infinite steps(8);
}
.spinner--steps2 {
	animation: anim-rotate 1s infinite steps(12);
}

body {
	font-family: sans-serif;
	color: #ccc;
	line-height: 1.5;
	font-size: 1em;
	background: #181818;
}
.talign-center {
	text-align: center;
}
footer {
	margin-top: 2em;
}
/******/
</style>



// WEBPACK FOOTER //
// src/components/funsiamo.vue